import { type IDataField } from '@telespot/domain';
import { type AssetMetadataWriter } from '../../ports';

export interface UpdateAssetMetadataPayload {
  assetId: string;
  data: IDataField;
}

export class UpdateAssetMetadataUseCase {
  constructor(private readonly writer: AssetMetadataWriter) {}

  public async execute(input: Readonly<UpdateAssetMetadataPayload>): Promise<void> {
    const { assetId, data } = input;

    await this.writer.save(assetId, data);
  }
}
